<template>
  <div class="personal-modulr-form-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-office-building"></i>Edit customer</span>
        
      </div>
      <el-form
        v-if="customerForm"
        :model="customerForm"
        id="customerForm"
        ref="customerForm"
        label-width="150px"
        size="small"
        :rules="customerFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-row :gutter="50">

          <el-col  :xs="24" :sm="24" :md="12" :lg="12">

            <el-divider content-position="left">Personal</el-divider>

            <el-form-item prop="firstName" label="First Name">
              <el-input v-model="customerForm.kyc.personalModulr.firstName"></el-input>
            </el-form-item>

            <el-form-item prop="lastName" label="Last Name">
              <el-input v-model="customerForm.kyc.personalModulr.lastName"></el-input>
            </el-form-item>

            <el-form-item prop="dateOfBirth" label="Date Of Birth">
              <el-date-picker
                v-model="customerForm.kyc.personalModulr.dateOfBirth"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="customerForm.kyc.personalModulr.telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="director_email" label="Email">
              <el-input
                prefix-icon="el-icon-message"
                v-model="customerForm.kyc.personalModulr.email"
              ></el-input>
            </el-form-item>

  

            <el-form-item
              prop="idAddress"
              label="Identify Address"
            >
              <el-input
                v-model="customerForm.kyc.personalModulr.idAddress"
              ></el-input>
            </el-form-item>



            <el-form-item prop="director_addressnumber" label="Address number">
              <el-input v-model="customerForm.kyc.personalModulr.addressnumber"></el-input>
            </el-form-item>

            <el-form-item prop="director_street" label="Street">
              <el-input v-model="customerForm.kyc.personalModulr.street"></el-input>
            </el-form-item>

            <el-form-item prop="director_city" label="City">
              <el-input v-model="customerForm.kyc.personalModulr.city"></el-input>
            </el-form-item>

            <el-form-item prop="director_zipcode" label="Zipcode">
              <el-input v-model="customerForm.kyc.personalModulr.zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="director_countrycode" label="Country code">
              <el-autocomplete
                class="inline-input"
                v-model="customerForm.kyc.personalModulr.countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectDirectorCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">Status</el-divider>
            <el-form-item label="Status">
              <el-select
                v-model="customerForm.status"
                placeholder="please select status"
              >
                <el-option label="Active" value="active"></el-option>
                <el-option label="Disable" value="disable"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer text-center">
        <el-button type="primary" :loading="submiting" @click="submitCustomer()"
          >Submit</el-button
        >
        <el-button @click="cancelForm">Cancel</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getUtility, updateCustomer } from "@/api/customer";

export default {
  props: {
    formData: Object
  },
  computed: {
    ...mapGetters(["user_project"]),
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      submiting: false,
      dialogShow: false,
      errMsg: "",
      utility: {},
      customerForm: null,
      customerFormRules: {}//model.rules,
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },

    getFormData() {
      let formData = JSON.parse(JSON.stringify(this.customerForm));
      formData.name = `${this.customerForm.kyc.personalModulr.firstName} ${this.customerForm.kyc.personalModulr.lastName}`;
      formData.kyc = {
          personal: this.customerForm.kyc.personalModulr
      }
      
      return formData;
    },

    updateCustomer() {
      let formData = this.getFormData();
      this.submiting = true;
      this.errMsg = "";
      updateCustomer(formData.enduser_id, formData).then(
        ({ result, message }) => {
          this.submiting = false;
          if (result) {
            this.$notify({
              title: "Success",
              message: `Update Customer successfully`,
              type: "success",
              duration: 2000
            });
            this.cancelForm()
            this.$emit("on-submited", true);
          } else {
            this.errMsg =
              typeof message === "string" ? message : "Update Customer Error";
          }
        }
      );
    },
    submitCustomer() {
        this.$refs.customerForm.validate((valid) => {
          if (valid) {
            this.updateCustomer();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      
    },
    cancelForm() {
      if(this.$route.query.ref && this.$route.query.ref == 'customer'){
        this.$router.push(`/project/${this.user_project}?tab=customer`);
      }else if( this.$route.query.ref && this.$route.query.ref == 'info'){
        this.$router.push(`/customer/view/${this.user_project}/${this.customerForm.enduser_id}`);
      }else{
        this.$router.push('/customer')
      }
      
    },
    resetForm() {
      if (this.$refs.customerForm) this.$refs.customerForm.resetFields();
    },
    querySearchCountrycode(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      // const lists = []
      // results.forEach((item)=>{
      //   lists.push({value : item.country_code})
      // })
      cb(results);
    },
    querySearchResidentCountry(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      // const lists = []
      // results.forEach((item)=>{
      //   lists.push({value : item.country_name})
      // })
      cb(results);
    },
    querySearchNationality(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "nationality"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.nationality });
      });
      cb(lists);
    },
    querySearchNatureofbusiness(queryString, cb) {
      var data = this.utility.natureofbusiness;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "name"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.name });
      });
      cb(lists);
    },

    selectDirectorCountrycode(item) {
      this.customerForm.kyc.personalModulr.countrycode = item.country_code;
    },
 
    createFilter(queryString, key) {
      return (item) => {
        return item[key].toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },

  },
  mounted() {
    this.getUtility();
    this.customerForm = this.formData;
  },
};
</script>

<style lang="scss">
.personal-modulr-form-container {
  .el-form-item--small.el-form-item {
    margin-bottom: 16px;
  }
  .item__label {
    line-height: 30px;
    font-weight: bold;
  }

  .el-form-item__label {
    font-size: 12px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 14px;
    color: #424242;
  }

}
</style>